import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config'
import details from './modules/details'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    config,
    details
  },
  strict: debug
})
